import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogTitle,
  Divider,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const CommonDialog = ({
  open = false,
  onClose = () => {},
  minWidth = "400px",
  title = "Title",
  children,
  fullWidth = false,
  maxWidth = "sm",
  paperSx,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          minWidth: { xs: "98%", md: minWidth },
          ...(paperSx && typeof paperSx === "object" ? paperSx : {}),
        },
      }}
    >
      <DialogTitle sx={{ p: "0 !important" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ py: 1, px: 2 }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              ":hover": { cursor: "-webkit-grab" },
            }}
            color="primary"
            id="draggable-dialog-title"
          >
            {title}
          </Typography>
          <Box
            onClick={onClose}
            sx={{
              cursor: "pointer",
              height: "25px",
              width: "25px",
              border: "2px solid #0C2F49",
              borderRadius: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Close sx={{ color: "#0C2F49" }} />
          </Box>
        </Stack>
        <Divider sx={{ backgroundColor: "#0C2F49", mb: 1 }} />
      </DialogTitle>
      {children}
    </Dialog>
  );
};

export default CommonDialog;
